import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportQuotation } from './Quotation.service';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useQuotationReport() {
  return useMutation(getQuestReportQuotation, {
    onSuccess() {
      notification.success({
        message: 'O relatório de cotação foi gerado com sucesso!',
      });
    },

    onError(error) {
      reportNotificationError(error);
    },
  });
}
